(function($) {
    var root;
    var force_open_timeout;
    var dropdown;
    var cookie_name = 'view_widget_nl';
    var cookie_duration = 2 * 24 * 60 * 60 * 1000; // durée du cookie en ms
    var form;
    var field_email;
    var message_success;
    var message_error;

    function init() {
        root = document.querySelector('.js-widget-nl');
        dropdown = root.querySelector('.js-dropdown');
        form = root.querySelector('form');
        field_email = form.querySelector('input[name="email-popin-nl"]');
        message_success = root.querySelector('.js-message-success');
        message_error = root.querySelector(".js-message-error");

        var opener = root.querySelector('.js-opener');
        opener.addEventListener('click', open_dropdown);

        var close_button = root.querySelector('.js-close');
        close_button.addEventListener('click', hide_dropdown);

        var view_widget_recently = get_cookie(cookie_name);
        if (!view_widget_recently) {
            // Si le widget n'a pas été vu récement, on l'ouvre au bout de 5 secondes
            force_open_timeout = setTimeout(open_dropdown, 5000);
            set_cookie(cookie_name, '1', cookie_duration);
        }

        form.addEventListener('submit', validate_form);
    }

    function open_dropdown() {
        if (force_open_timeout) clearTimeout(force_open_timeout);
        dropdown.classList.add('is-visible');
    }

    function hide_dropdown() {
        dropdown.classList.remove('is-visible');
    }

    function validate_form(ev) {
        ev.preventDefault();

        message_error.style.display = 'none';

        var has_error = false;
        var is_email_valid = validate_email(field_email.value);
        if (!is_email_valid) {
            has_error = true;
            message_error.style.display = '';
            setTimeout(function() {
                message_error.style.display = "none";
            }, 3000);
        }

        if (has_error) return;

        jQuery.ajax({
            type: 'POST',
            url: adminAjax,
            data: {
                'email-popin-nl': field_email.value,
                'action': 'subscribe_newsletter'
            },
            success: function(data) {
                if (data.success === true) {
                    display_success();
                }
            },
            error: function() {}
        });
    }

    function display_success() {
        message_success.style.display = '';

        setTimeout(function() {
            hide_dropdown();
            field_email.value = '';
            message_success.style.display = 'none';
        }, 5000);
    }

    function validate_email(email) {
        var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return re.test(email);
    }

    function get_cookie(name) {
        var cookies = document.cookie;
        if (cookies.length == 0) return;
        var start = cookies.indexOf(name + "=");
        if (start == -1) return;
        start = start + name.length + 1;
        var end = cookies.indexOf(";", start);
        if (end == -1) {
            end = cookies.length;
        }
        return unescape(cookies.substring(start, end));
    }

    function set_cookie(name, value, days){
        var expires;
        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }
        else {
            expires = "";
        }
        document.cookie = name + "=" + value + expires + ";path=/";
    }
    
    init();

})();